<template>
	<div class="newsports_rank">
		<Row type="flex" class="myinfo" justify="space-between" align="bottom">
			<Col span="9">
			<div class="myavatar">
				<VanImage :src="myinfo.avatar" />
			</div>
			<div class="myrank">
				<template v-if="+myinfo.rank > 0">排名 {{ myinfo.rank }}</template>
				<template v-else>暂无排名</template>
			</div>
			</Col>
			<Col span="9">
				<div style="padding-bottom: .3rem;font-size:.35rem;">
					{{ myinfo.name ? myinfo.name : myinfo.nickname }}</div>
				<div style="font-weight: bold;font-size:.45rem;">
					<span v-if="+myinfo.state === 1">
						<template >{{myinfo.score}} 分</template>
					</span>
					<span v-else-if="+myinfo.state === 3">
						审核不通过
					</span>
					<span v-else-if="!myinfo.state"></span>
					<span v-else>待审核</span>
				</div>
			</Col>
		</Row>

		<List style="color:#F8F8F8;" v-model="loading" :finished="finished" finished-text="没有更多了" @load="getRankList">
			<div class="rank-list">
				<div class="filter">
					<div v-for="(item, index) in filter" :key="index" class="item" :class="{ active: item.active == 1 }"
						@click="onChange(item)">{{ item.value }}</div>
				</div>
				<CellGroup v-if="rankList.length" :border="false">
					<Cell v-for="item in rankList" :key="item.id" center class="rank">
						<div slot="title">{{item.name||item.nickname}}</div>
						<div slot="icon" class="rank_icon">
							<template v-if="item.rank <= 3">
								<img src="@/assets/img/rank/first.png" :alt="item.rank" v-if="item.rank == 1" />
								<img src="@/assets/img/rank/second.png" :alt="item.rank" v-if="item.rank == 2" />
								<img src="@/assets/img/rank/third.png" :alt="item.rank" v-if="item.rank == 3" />
							</template>

							<span v-else>{{ item.rank }}</span>
							<VanImage :src="item.avatarurl" />
						</div>
						<div slot="label" v-if="item.create_time">{{ (systime - item.create_time) | diffentTime(item.create_time) }}
						</div>


						<template v-if="item_sub_id != 4701">
							<span v-if="animation==1" @click="goshow(item)"
								style="color:#1989fa;">查看视频 </span>
							<span v-if="+item.state !== 3"> 
								{{ type == 9 ? item.duration : item.score*1 }}{{sports_item_id==368? '分' :type|SportsItemtype}}</span>
							<span class="desc" v-else>不符合规定<br />审核不通过</span>
						</template>

						<template v-else>{{ item.score*1 }} km</template>
					</Cell>
				</CellGroup>
				<Empty style="background: #fff;min-height: 6rem" :style="`border-radius: ${borderRadius}`" v-else
					description="暂无数据" />
			</div>
		</List>
		<Popup v-model="showVideo" closeable :style="{ height: '50%',width: '80%' }">
			<video id="video" :src="videoUrl" x5-video-player-type="h5" playsinline="true" x5-playsinline="true" autoplay
				webkit-playsinline="true" height="100%" width="100%">您的浏览器不支持播放该视频！</video>
		</Popup>
	</div>
</template>

<style lang="less" scoped>
	@import "./index.less";

	.filter {
		width: 6.9rem;
		margin: 0 auto;
		display: flex;
		align-items: center;

		.item {
			font-size: 0.3rem;
			padding: 0.12rem 0;
			width: 2rem;
			display: flex;
			justify-content: center;
			border-radius: 0.2rem 0.2rem 0 0;

			&.active {
				background: #fff;
				color: #333;
			}
		}
	}
</style>

<script>
	import {
		Empty,
		Panel,
		Cell,
		CellGroup,
		Image,
		List,
		Row,
		Col,
		Popup
	} from "vant";

	export default {
		filters: {
			SportsItemtype(type){
				switch (type){
					case 9:
						return ''
						break;
					default:
						return ''
						break;
				}
				
			}
		},
		computed: {
			buttonColor() {
				let detail = this.detail;
				if (!detail) return "#ccc";
				return `${detail.tabstyle[0]["color"]}`;
			},
			borderRadius() {
				if (this.filter) {
					let i = this.filter.findIndex((row) => {
						return row.active == 1;
					});
					if (i == 0) {
						return "0 .2rem .2rem .2rem";
					} else {
						return ".2rem";
					}
				}
			},
		},
		components: {
			Empty,
			Panel,
			Cell,
			CellGroup,
			List,
			VanImage: Image,
			Row,
			Col,
			Popup
		},
		props: ["item_sub_id", "sports_id", "item_id"],
		data() {
			return {
				rankList: [],
				loading: false,
				finished: false,
				detail: "",
				page: 1,
				systime: "",
				myinfo: "",
				register_type: "",
				filter: [],
				type: "",
				physical_item_id: 0,
				sports_item_id: 0,
				showVideo: false,
				videoUrl: '',
				animation: 0
			};
		},
		methods: {
			goshow(row) {
				this.videoUrl = row.animationurl
				this.showVideo = true
				setTimeout(function() {
					var video = document.querySelector('#video');
					video.play();
				}, 1000);


			},
			onChange(row) {
				if (this.loading) return;
				this.filter.forEach((item) => {
					item.active = 0;
				});
				row.active = 1;
				this.register_type = row.value;
				this.rankList = [];
				this.page = 1;
				this.getRankList();
			},
			getRankList: function() {
				//如果为空or 0 按照 item_id  rank
				if (!+this.item_sub_id) {
					this.$api.sports
						.getSportsItemRank({
							id: this.item_id,
							page: this.page
						})
						.then((res) => {
							let {
								page,
								list
							} = res.data;
							this.systime = res.sys_time;
							this.loading = false;
							if (+page.currentPage === 1) {
								this.rankList = list;
							} else {
								this.rankList = this.rankList.concat(list);
							}

							let t = null

							this.rankList.forEach((item, index) => {
								item = Object.assign(item, item.userInfo);
								item.score = +item.total_score ? item.total_score : 0;
								if (t == null) {
									t = item;
									t.rank = index + 1;
								} else {
									var n = item;
									if (n.score * 1 == t.score * 1) {
										n.rank = t.rank;
									} else {
										n.rank = index + 1;
									}
									t = n;
								}
							})

							if (+page.currentPage >= page.pageCount) {
								this.finished = true;
							} else {
								this.page++;
							}
						});
				} else {
					if (this.$route.query.rank_type == 2) {
						this.$api.sports
							.compareRankAll(
								Object.assign({
									cpgid: this.item_sub_id,
									page: this.page,
									sort: 2,
									register_type: this.register_type,
								})
							)
							.then((res) => {
								if (+res.status !== 200) {
									this.finished = true;
									return;
								}
								this.systime = res.sys_time;
								this.loading = false;
								let {
									list,
									page,
									pages,
									myinfo,
									type,
									physical_item_id,
									sports_item_id,
									animation
								} = res.data;
								this.myinfo = myinfo;
								this.type = type;
								this.physical_item_id = physical_item_id;
								this.sports_item_id = sports_item_id;
								this.filter = res.data.filter;
								this.animation = animation;
								if (page == 1) {
									this.rankList = list;
								} else {
									this.rankList = this.rankList.concat(list);
								}

								let t = null

								this.rankList.forEach((item, index) => {
									if (t == null) {
										t = item;
										t.rank = index + 1;
									} else {
										var n = item;
										if (n.score * 1 == t.score * 1) {
											n.rank = t.rank;
										} else {
											n.rank = index + 1;
										}
										t = n;
									}
								})

								if (page >= pages) {
									this.finished = true;
								} else {
									this.page++;
								}
							});
					} else {
						this.$api.sports
							.compareRank2(
								Object.assign({
									cpgid: this.item_sub_id,
									page: this.page,
									sort: 2,
									register_type: this.register_type,
								})
							)
							.then((res) => {
								if (+res.status !== 200) {
									this.finished = true;
									return;
								}
								this.systime = res.sys_time;
								this.loading = false;
								let {
									list,
									page,
									pages,
									myinfo,
									type,
									physical_item_id,
									sports_item_id,
									animation
								} = res.data;
								this.myinfo = myinfo;
								this.type = type;
								this.physical_item_id = physical_item_id;
								this.sports_item_id = sports_item_id;
								this.filter = res.data.filter;
								this.animation = animation;
								if (page == 1) {
									this.rankList = list;
								} else {
									this.rankList = this.rankList.concat(list);
								}

								let t = null

								this.rankList.forEach((item, index) => {
									if (t == null) {
										t = item;
										t.rank = index + 1;
									} else {
										var n = item;
										if (n.score * 1 == t.score * 1) {
											n.rank = t.rank;
										} else {
											n.rank = index + 1;
										}
										t = n;
									}
								})

								if (page >= pages) {
									this.finished = true;
								} else {
									this.page++;
								}
							});
					}

				}
			},
			init: function() {
				this.$toast.loading({
					duration: 0,
				});
				let params = {
					cpgid: this.item_sub_id
				};
				this.$api.sports.sportsMain(this.sports_id).then((res) => {
					let {
						bgstyle,
						id,
						tabstyle,
						introstyle,
						title
					} = res.data;
					try {
						bgstyle = JSON.parse(bgstyle);
						tabstyle = JSON.parse(tabstyle);
						introstyle = JSON.parse(introstyle);
					} catch (e) {
						console.error(e);
					}
					this.detail = {
						id,
						bgstyle,
						tabstyle,
						introstyle,
						title
					};
					this.$toast.clear();
				});

				if (!+this.item_sub_id) {
					this.$api.sports
						.getMySportsItemRank({
							id: this.item_id
						})
						.then((res) => {
							this.myinfo = res.data;
						});
				}
			},
		},
		mounted() {
			this.init();
			// this.getRankList();
		},
	};
</script>